import { markRaw } from 'vue'
// eslint-disable-next-line no-restricted-imports
import { toast as libToast } from 'vuetify-sonner'

import AppToast from '@/design-system/toast/AppToast.vue'
import type { ToastOptions, ToastVariant } from '@/design-system/toast/types'

const RawAppToast = markRaw(AppToast)

// Toasts stay 5s by default; richer toasts (with a caption and/or an action/link) get
// longer so there is time to read them and interact.
const DEFAULT_DURATION = 5000
const EXTENDED_DURATION = 10000

let counter = 0
function nextId (): string {
  return `app-toast-${Date.now()}-${counter++}`
}

function show (variant: ToastVariant, message: string, options?: ToastOptions) {
  const { caption, action, link, duration } = options ?? {}

  const hasRichContent = Boolean(caption || action || link)
  const resolvedDuration = duration ?? (hasRichContent ? EXTENDED_DURATION : DEFAULT_DURATION)

  return libToast.toastOriginal.custom(RawAppToast, {
    id: nextId(),
    duration: resolvedDuration,
    unstyled: true,
    componentProps: {
      variant,
      message,
      caption,
      action,
      link,
    },
  } as any)
}

export const toast = {
  info: (message: string, options?: ToastOptions) => show('info', message, options),
  success: (message: string, options?: ToastOptions) => show('success', message, options),
  warning: (message: string, options?: ToastOptions) => show('warning', message, options),
  error: (message: string, options?: ToastOptions) => show('error', message, options),
  dismiss: (id?: string | number) => libToast.dismiss(id),
}
